import React from 'react';
import styled, { css } from 'styled-components';
import { TextInput } from './TextInput';
import { TextArea } from './TextArea';
import { formTextElementStyles, formTextBackgroundStyles, useFormTextStateProps, useTextInputVariantProps, useTextAreaVariantProps, } from './context';
const InlineWrapper = styled.div `
  display: flex;
`;
const StackedWrapper = styled.div `
  width: 100%;
`;
const InlineTextWrapper = styled.div `
  ${({ $inputWidth }) => `
    display: inline-block;
    position: relative;
    width: ${$inputWidth || '100%'};
    max-width: 500px;
  `}
`;
export const FormTextElementWrapper = ({ formTextElement, formFieldHelper, inlineContextualHelp, characterCounter, inputWidth, }) => {
    return (React.createElement(StackedWrapper, null,
        React.createElement(InlineWrapper, null,
            React.createElement(InlineTextWrapper, { "$inputWidth": inputWidth },
                formTextElement,
                characterCounter),
            inlineContextualHelp),
        formFieldHelper));
};
const StyledBaseTextInput = styled(TextInput) `
  ${formTextElementStyles}
  ${formTextBackgroundStyles}
`;
const StyledBaseTextArea = styled(TextArea) `
  ${formTextElementStyles}
  ${formTextBackgroundStyles}
  ${({ characterCounter }) => `
    ${(characterCounter === null || characterCounter === void 0 ? void 0 : characterCounter.show)
    ? css `
            padding-bottom: 25px;
            scroll-padding-bottom: 25px;
          `
    : css ``}
  `}
`;
export const BaseTextInput = React.forwardRef((props, ref) => {
    const textInputVariantProps = useTextInputVariantProps(props);
    const formTextStateProps = useFormTextStateProps({});
    const { characterCounterWidth, characterCounter } = props;
    return (React.createElement(StyledBaseTextInput, Object.assign({ ref: ref, "$paddingRight": (characterCounter === null || characterCounter === void 0 ? void 0 : characterCounter.show) && characterCounterWidth
            ? characterCounterWidth
            : 8 }, props, formTextStateProps, textInputVariantProps)));
});
export const BaseTextArea = React.forwardRef((props, ref) => {
    const textAreaVariantProps = useTextAreaVariantProps(props);
    const formTextStateProps = useFormTextStateProps({});
    return (React.createElement(StyledBaseTextArea, Object.assign({ ref: ref }, props, formTextStateProps, textAreaVariantProps, (formTextStateProps.$isDisabled ? { resizable: false } : {}))));
});
//# sourceMappingURL=BaseFormText.js.map